/**
 * Navigation configuration for Faraid module
 * Uses translation keys (labelKey, titleKey) instead of direct strings
 * Transform with useNavigation() composable to get localized labels
 */
export const faraidNavSections = [
  {
    titleKey: 'nav.main',
    items: [
      {
        id: 'dashboard',
        labelKey: 'nav.dashboard',
        icon: 'dashboard',
        path: '/',
      },
      {
        id: 'calculator',
        labelKey: 'nav.calculator',
        icon: 'calculator',
        path: '/calculator',
      },
      {
        id: 'cases',
        labelKey: 'nav.cases',
        icon: 'folder',
        path: '/cases',
      },
    ],
  },
  {
    titleKey: 'nav.scholar',
    items: [
      {
        id: 'scholar-queue',
        labelKey: 'nav.scholarQueue',
        icon: 'inbox',
        path: '/scholar-queue',
      },
      {
        id: 'scholars',
        labelKey: 'nav.scholars',
        icon: 'users',
        path: '/scholars',
      },
    ],
  },
  {
    titleKey: 'nav.system',
    items: [
      {
        id: 'messages',
        labelKey: 'nav.messages',
        icon: 'message',
        path: '/messages',
      },
      {
        id: 'settings',
        labelKey: 'nav.settings',
        icon: 'settings',
        path: '/settings',
      },
    ],
  },
]
